// ** redux imports
import { createSlice } from '@reduxjs/toolkit';

// initial states
const initialState = {};

export const taxFilesSlice = createSlice({
  name: 'taxFiles',
  initialState,
  reducers: {},
});

export const {} = taxFilesSlice.actions;

export default taxFilesSlice.reducer;
